window.__tnt || (window.__tnt = {});
__tnt.video || (__tnt.video = {});
__tnt.video.blox || (__tnt.video.blox = {});
__tnt.video.plugins || (__tnt.video.plugins = {});
__tnt.video.advertising || (__tnt.video.advertising = function(player){__tnt.log("No video ad callback configured.")});

__tnt.video.mimetype = function(a){
    var mimetype = "video/mp4";
    if(typeof(a)=="string"){
        if(a.match(/\.flv/)!=null){
            mimetype = "video/x-flv";
        }
    }        
    return mimetype;
}

__tnt.video.pause = function(player){
    var _playing = __tnt.video.blox.players[player.id()].playing;
    
    if(player.remainingTime()>.2 && player.currentTime()>.2 && _playing){
        //__tnt.log("User - Paused video");

        __tnt.trackEvent({'category':'video','action':'video paused','label':'user paused: '+player.currentSrc(),'value':'1'});
        
        __tnt.video.blox.players[player.id()].paused = true;
        
        player.one('play',function(event){

        });
    }else if(player.currentTime()<.2){
        //__tnt.log("Player - Auto paused video at start");
    }
};


__tnt.video.register = function(player){
    __tnt.video.blox.players || (__tnt.video.blox.players = []);
    if(typeof(__tnt.video.blox.players[player.id()])=='undefined'){
        __tnt.video.blox.players.push(player.id());
        __tnt.video.blox.players[player.id()] = {
            src: player.currentSrc(),
            playing: false,
            playLogged: false,
            paused: false,
            stalled: 0,
            lastFrame: 0,
            endcard:true
        };
    }
};

__tnt.video.callback || (__tnt.video.callback = function(player){
    __tnt.video.register(player);    

    player.on('__tnt.video.initialize',function(){
        //__tnt.log("Player - Initializing Player");
        
        __tnt.video.blox.players[player.id()].playing = false;
        __tnt.video.blox.players[player.id()].paused = false;
        
    });
    
    player.on('play',function(event){
        //__tnt.log("Player - Play Event");
        var _playing = __tnt.video.blox.players[player.id()].playing;
        var _paused = __tnt.video.blox.players[player.id()].paused;

        if(!(_playing)){
            //__tnt.log("Player - Playing Check Passed");

            __tnt.video.blox.players[player.id()].playing = true;

            // ensure that only one blox player is playing 
            $.each(__tnt.video.blox.players, function(index, item) {
                if(player.id() != item && __tnt.video.blox.players[item].playing){
                    videojs(item).pause();
                }
            });

            $(player.contentEl()).find('.vjs-loading-spinner').css({'display':'none'});
            $(player.posterImage.el()).css({'display':'none'});

            if(!__tnt.video.blox.players[player.id()].playLogged){
                __tnt.video.blox.players[player.id()].playLogged = true;
                __tnt.trackEvent({'category':'video','action':'video playing','label':'user watching: '+__tnt.video.blox.players[player.id()].src,'value':'1'});
            }
            
            var endcard = $('#'+player.id()+'-engagement');
            if(endcard && __tnt.engagement){
                //__tnt.log("Player - Pre-populating end card");
                
                if(endcard.find('.engagement-container').find('.engagement-item').length<1){
                    var assetId = player.id().replace('video-player-',''); 
                     
                    if(__tnt.engagement.assets.length && assetId && typeof(__tnt.engagement.assets[assetId].populate())==='function'){
                        __tnt.engagement.assets[assetId].populate();
                    }
                }
            }
        }else if(_paused){
            //__tnt.log("Player - Resumed video");

            __tnt.trackEvent({'category':'video','action':'video resumed','label':'user resumed: '+player.currentSrc(),'value':'1'});
            
            __tnt.video.blox.players[player.id()].paused = false;
        }else{
            //__tnt.log("Player - Failed Playing Check");
        }
    });
    
    player.on('pause',function(event){
        __tnt.video.pause(player);

        __tnt.video.blox.players[player.id()].playing = false;
    });
    
    player.on('ended',function(event){
        //__tnt.log("Player - Ended");
        
        var _playing = __tnt.video.blox.players[player.id()].playing;
        
        if(_playing){
            //__tnt.log("Player - Ended");
            
            // Track ended event
            __tnt.log("Player - Ended - passed playing check");
            __tnt.trackEvent({'category':'video','action':'video ended','label':'user watched: '+__tnt.video.blox.players[player.id()].src,'value':'1'});

            __tnt.video.blox.players[player.id()].playing = false;
            __tnt.video.blox.players[player.id()].playLogged = false;
               
                setTimeout(function() {
                    
                    var endcard = $('#'+player.id()+'-engagement');
                    
                    // ensure that the endcard is within the player
                    $('#'+player.id()).append(endcard.clone());
                    endcard.remove();
            
                    var endcard = $('#'+player.id()+'-engagement');
            
                    if(endcard && __tnt.video.blox.players[player.id()].endcard && __tnt.engagement && !player.remainingTime()){
                        __tnt.log("Player - Displaying end card");
                        
                        __tnt.log("Player - Running engagement module");
                        if(endcard.find('.engagement-container').find('.engagement-item').length<1){
                        console.log("ENDCARD - NO ASSETS FOUND");
                            var assetId = player.id().replace('video-player-','');
                            
                            if(__tnt.engagement.assets.length && assetId && typeof(__tnt.engagement.assets[assetId].populate())==='function'){
                                __tnt.engagement.assets[assetId].populate();
                                
                                $(player.bigPlayButton.el()).css({'display':'none'});
                                $(player.controlBar.el()).css({'display':'none'});
                                endcard.css({'display':'block'});
                                endcard.css({'display':'none'});
                                endcard.find('.engagement-spinner').hide();

                                player.currentTime(0);
                                player.trigger('loadstart');
                            }
                        }else if(endcard.find('.engagement-container').attr('data-engagement-total')>0){
                            endcard.removeClass('hide').css({'display':'block'});

                        }else{
                            endcard.css({'display':'none'});
                            $(player.bigPlayButton.el()).css({'display':'block'});                        
                            endcard.find('.engagement-spinner').hide();

                        }
                        
                        
                    }else if(player.remainingTime()<.01){
                        endcard.removeClass('hide').css({'display':'none'});
                    }else{
                        __tnt.log("Player - No Endcard Display");
                        player.trigger('__tnt.video.initialize');
                    }
                    
                    endcard.on('click',function(){
                        endcard.hide();
                        player.play();
                    });
                }, 500);


        }
    });         
    
    player.trigger('__tnt.video.initialize');
});


$(function(){    
    $('video.tnt-video').each(function(){

        var element = $(this);

        element.attr('controls','true');
        element.addClass("video-js vjs-default-skin vjs-big-play-centered vjs-16-9");
        videojs(element[0],{
            fluid:true,
            plugins:__tnt.video.plugins
        },function(){  
            player = this;
            
            if(typeof(__tnt.video.advertising)==='function'){
                __tnt.video.advertising(player);
            }

           
           if(navigator.userAgent.indexOf('MSIE')!==-1 || navigator.appVersion.indexOf('Trident/') > 0 || navigator.userAgent.indexOf('Edge/')){
               $('#'+player.id()).css({'padding-top':'56.25%'});
           }
           
           if(player.panorama){
               player.panorama({
                   clickToToggle: true,
                   clickAndDrag: true,
                   autoMobileOrientation: true,
                   initFov: 100,
                   NoticeMessage: "drag to adjust view of the video",
                   callback: function () {
                       $(player.contentEl()).find('video').first().show();
                       
                   }
               });
           }
           
           __tnt.video.callback(player);
        });

    });
});